import { BaseException } from "@/exceptions/base-exception.exception.ts"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights.ts"

export class NonChonologicalTimesException extends BaseException {
  exceptionId = "NON_CHRONOLOGICAL_TIMES"
  title = "Niet chronologisch"
  weight = ExceptionWeights.ERROR

  public getMessage(): string {
    return "De eindtijd van een dienst kan niet voor de begintijd liggen."
  }
}
